import { render } from "./FadeTransition.vue?vue&type=template&id=35786fc5&ts=true"
import script from "./FadeTransition.vue?vue&type=script&lang=ts"
export * from "./FadeTransition.vue?vue&type=script&lang=ts"

import "./FadeTransition.vue?vue&type=style&index=0&id=35786fc5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__